module.exports = __webpack_public_path__ + "static/59-seconds-bbe1db63302314a47993cf4176718dec.jpg";